import React, { useEffect, useState } from "react";
import { Images } from "../../Assets/Index";
import Commontable from "../../Components/Commontable";
import { getResultDetails } from "../../ApiServices/Apifun";
import { Button } from "antd";
import { dispatchtoast, getLocalStorageItem } from "../../Utils";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const LeaderBoard = () => {
  const [leaderboardData, setLeaderBoardData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const location = useLocation();
  const lottery_id = location?.state?.lottery_id;

  const getData = () => {
    const formdata = new FormData();
    formdata.append("lottery_id", lottery_id);
    getResultDetails(formdata)
      .then((res) => {
        if (res.status && res.data.data.length !== 0) {
          const newItems = res.data.data.map((i) => {
            const isCurrentUser =
              i.user_id === getLocalStorageItem("userDetails")?.id;
            return {
              Id: (
                <p
                  className={` ${
                    isCurrentUser
                      ? "bg-[#f2a715] text-black w-full rounded-l-md p-2 flex justify-center items-center"
                      : ""
                  }`}
                >
                  {i.purchase_id??"--"}
                </p>
              ),
              Name: (
                <p
                  className={`capitalize ${
                    isCurrentUser
                      ? "bg-[#f2a715] text-black w-full  p-2 flex justify-center items-center"
                      : ""
                  }`}
                >
                  {i.name}
                </p>
              ),
              Rank: (
                <p
                  className={`capitalize ${
                    isCurrentUser
                      ? "bg-[#f2a715] text-black w-full  p-2 flex justify-center items-center"
                      : ""
                  }`}
                >
                  {i.rank}
                </p>
              ),
              Prize: (
                <p
                  className={`capitalize ${
                    isCurrentUser
                      ? "bg-[#f2a715] text-black w-full rounded-r-md  p-2 flex justify-center items-center"
                      : ""
                  }`}
                >
                  {i.prize_amount}
                </p>
              ),
            };
          });
          setTotalPages(res.data.total_pages);
          setLeaderBoardData((prevResults) => [...prevResults, ...newItems]);
          setTotalItems((prevTotal) => prevTotal + res.data.data.length); // Update total items
        } else {
          dispatchtoast("No Data Available!", true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  const handleLoad = () => {
    setLoading(true);
    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <>
      <div className="flex justify-center mt-4 pb-20 items-center">
        <div className="w-full">
          <div className="flex justify-between bg-[#f2a715] px-8 py-2 rounded-lg gap-x-3 items-center">
            <div className="text-black font-semibold flex-col justify-between items-center">
              <p className="text-xl font-semibold">Leader Board</p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-black font-semibold">Rs. {walletBalance}</p>
            </div>
          </div>
          <div className="overflow-y-scroll 2xl::h-[520px] xl:h-[800px] sm:h-full h-full mt-4 ">
            <Commontable
              rows={leaderboardData}
              gridNum={4}
              column={["Id","Name", "Rank", "Prize"]}
            />
          </div>
          {totalItems >= 10 &&
            totalPages > page && ( // Only show the button if there are at least 10 items and more pages to load
              <div className="mt-4 flex justify-center items-center">
                <Button
                disabled={totalPages ===page}
                  onClick={handleLoad}
                  loading={loading}
                  className="bg-darkPurple text-black hover:border-none border-none outline-none hover:outline-none"
                >
                  Load More
                </Button>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default LeaderBoard;
